import { Locales } from '../../localization/react'

function getDpaPdf(urlLocale: Locales): string {
  switch (urlLocale) {
    case 'de':
      return 'https://eversports-drivers.s3.eu-central-1.amazonaws.com/eversmile/Auftragsverarbeitungsvertrag.AVV.pdf'
    case 'en':
      return 'https://eversports-drivers.s3.eu-central-1.amazonaws.com/eversmile/Eversports_Data-Processing-Agreement.pdf'
    default:
      return 'https://eversports-drivers.s3.eu-central-1.amazonaws.com/eversmile/Eversports_Data-Processing-Agreement.pdf'
  }
}

export default getDpaPdf
